import { render, staticRenderFns } from "./PowerRewriteRight.vue?vue&type=template&id=2d731887&scoped=true"
import script from "./PowerRewriteRight.vue?vue&type=script&lang=js"
export * from "./PowerRewriteRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d731887",
  null
  
)

export default component.exports